(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/account-selector/assets/javascripts/account-list-item.js') >= 0) return;  svs.modules.push('/components/marketplace/account-selector/assets/javascripts/account-list-item.js');

'use strict';

const {
  format
} = svs.utils;
const AccountListItem = _ref => {
  let {
    activatedDrawId,
    groupName,
    balance,
    selectedAcc,
    onSelect,
    sharePrice
  } = _ref;
  return React.createElement("li", {
    className: "account-list-item list-group-item"
  }, React.createElement("input", {
    checked: selectedAcc === activatedDrawId,
    className: "form-toggle-input form-toggle-radio form-toggle-default qa-group-select",
    id: "radio-".concat(activatedDrawId),
    name: "radio-btn-group-marketplace",
    onChange: () => onSelect(activatedDrawId),
    type: "radio",
    value: "1"
  }), React.createElement("label", {
    className: "form-label padding-1".concat(selectedAcc === activatedDrawId ? ' qa-is-checked' : ''),
    htmlFor: "radio-".concat(activatedDrawId)
  }, React.createElement("div", {
    className: "form-label-btn"
  }), React.createElement("div", {
    className: "form-label-text qa-account-label"
  }, React.createElement("strong", null, groupName), activatedDrawId === 'user' ? React.createElement("div", null, "Spelbart saldo:", format.Currency(balance), ' ', "kr") : React.createElement("div", null, React.createElement("div", {
    className: "left"
  }, "Andelspris:", ' ', format.Currency(sharePrice), ' ', "kr"), ' ', React.createElement("div", {
    className: "right"
  }, "Att spela f\xF6r:", ' ', format.Currency(balance), ' ', "kr")))));
};
setGlobal('svs.components.marketplace.accountSelector.AccountListItem', AccountListItem);

 })(window);